module.exports = __webpack_public_path__ + "img/Number=99.2e04efb0.png";